import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { OctroiModele } from '../../../octroi/modeles/octroiModele';
import { GtmService } from '../../services/gtm.service';
import {
  GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
  GTM_PUSH_CATEGORY,
  StatusPreautorisation
} from '../../modeles/variables';
import { ToolPreautorisationService } from '../../../tool-preautorisation/tool-preautorisation.service';

@Component({
  selector: 'app-card-next-step',
  templateUrl: './card-next-step.component.html',
  styleUrls: ['./card-next-step.component.scss'],
  standalone: false
})
export class CardNextStepComponent implements OnInit {
  @Input()
  step: string;

  @Select(state => state.octroi.lastOctroi)
  lastOctroi$: Observable<OctroiModele>;

  displayEmmenagement: boolean;
  displayOffreAchat: boolean;
  displayPretAssurances: boolean;
  displayPreauth: boolean;
  displayPropriete: boolean;
  displayActeVente: boolean;
  preautoriationLink: string;

  status$: Observable<StatusPreautorisation>;

  activePreauth: boolean;
  activeOctroi: boolean;

  constructor(
    private readonly _router: Router,
    private readonly _gtm: GtmService,
    private readonly _toolPreautorisationService: ToolPreautorisationService
  ) {}

  ngOnInit() {
    this.displayEmmenagement = false;
    this.displayOffreAchat = false;
    this.displayPretAssurances = false;
    this.displayPropriete = false;
    this.displayPreauth = false;
    this.activePreauth = false;
    this.displayActeVente = false;
    this.preautoriationLink = '/preautorisation-simplifiee';
    switch (this.step) {
      case 'emmenagement': {
        this.displayEmmenagement = true;
        break;
      }
      case 'propriete': {
        this.displayPropriete = true;
        break;
      }
      case 'offre-achat': {
        this.displayOffreAchat = true;
        break;
      }
      case 'pret-assurances': {
        this.displayStatusOctroi();
        break;
      }
      case 'acte-vente': {
        this.displayActeVente = true;
        break;
      }
      case 'preauth': {
        this.displayPreauth = true;
        break;
      }
      default: {
        break;
      }
    }

    this.status$ = this._toolPreautorisationService.getStatusPreautorisation$;
  }

  displayStatusOctroi() {
    this.lastOctroi$.subscribe(data => {
      this.activeOctroi = !!data;
    });
    this.displayPretAssurances = true;
  }

  navigateTo(target: string, sectionName: string = null): void {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: this.getNextSectionName(sectionName),
      action: 'click - section suivante',
      value: 0,
      nonInteraction: false
    });

    this._router.navigateByUrl(target);
  }

  getNextSectionName(sectionName: string = null): string {
    const section = sectionName ? sectionName : this.step;

    const mapping = {
      propriete: 'Proprietes',
      preauth: 'Preautorisation',
      'offre-achat': "Offre d'achat",
      'pret-assurances': 'Pret et assurances',
      pret: 'Types de prets',
      'assurance-pret': 'Proteger mon pret',
      'assurance-habitation': 'Proteger ma maison',
      'acte-vente': 'Acte de vente',
      emmenagement: 'Demenagement'
    };

    return mapping[section] || null;
  }
}
